import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all states values
export const GET_HOLIDAYS_LIST = "GET_HOLIDAYS_LIST";
export const ADD_HOLIDAYS = "ADD_HOLIDAYS";
export const GET_SINGLE_HOLIDAYS_LIST = "GET_SINGLE_HOLIDAYS_LIST";


export const getHolidaysList = (Id) => (dispatch) => { // get all holidays data from api call
  axios.get(`schools/holiday/months/get`).then((res) => {
    dispatch({
      type: GET_HOLIDAYS_LIST,
      payload: res.data,
    });
  });
};

export const getsingleHolidaysList = (Id) => (dispatch) => { // get single holiday list for view holiday page api
  axios.get(`/schools/${Id}/holiday/get`).then((res) => {
    dispatch({
      type: GET_SINGLE_HOLIDAYS_LIST,
      payload: res.data,
    });
  });
};

export const addHolidays = (Id, data) => (dispatch) => { // create holiday api call
  axios
    .post(`/schools/holiday/create`, data, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: ADD_HOLIDAYS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};
